<template>
    <div class="root">
        <VueConfirmDialog :parent="_uid" />
        <section>
            <div class="container">
                <h3 class="rux-list-title">Profile</h3>
                <div class="col-12 grid border-bottom">
                    <div class="row">
                        <div class="col-12 col-sm-6 head">
                            NAME:
                        </div>
                        <div class="col-12 col-sm-6 no-padding roman">
                            <EditableInput @save="updatedInput(...arguments)" v-model="userProfile.name"
                                placeholder="Add your name" />
                        </div>
                    </div>
                </div>
                <div class="col-12 grid border-bottom">
                    <div class="row">
                        <div class="col-12 col-sm-6 head">
                            E-MAIL:
                        </div>
                        <div class="col-12 col-sm-6 roman">
                            {{ userProfile.email ? userProfile.email : 'No email on file' }}
                        </div>
                    </div>
                </div>
                <div class="col-12 grid border-bottom">
                    <div class="row">
                        <div class="col-12 col-sm-6 head">
                            REFERRAL LINK:
                        </div>
                        <div v-if=!isReferralLinkEmpty class="col-12 col-sm-6 roman flex-container">
                            {{ referralLink ? referralLink : "N/A"}}
                            <button @click="copyToClipboard" class="copy-button">
                                <span class="material-symbols-outlined copy-icon">file_copy</span>
                            </button>
                        </div>
                        <a v-if=isReferralLinkEmpty class="col-12 col-sm-6 roman" href='https://rux.life/pages/referral'>{{ "CREATE A REFERRAL LINK" }}</a>
                    </div>
                </div>
                <div class="col-12 grid border-bottom">
                    <div class="row" v-if="ruxList && ruxList.length > 0">
                        <div class="col-12 col-sm-6 head">
                            {{ ruxList.length > 1 ? 'SERIAL NUMBERS:' : 'SERIAL NUMBER:' }}
                        </div>
                        <div v-for="(item, index) in ruxList" :key="index" class="col-12 col-sm-6 roman flex-container">
                            {{ item.serialNumber }}
                            <div @click="deleteRux(item.serialNumber)"
                                class=" material-symbols-outlined deleteRux pointer">
                                delete_forever
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import EditableInput from './EditableInput'
import VueConfirmDialog from './ConfirmDialog/vue-confirm-dialog'
export default {
    name: 'userProfile',
    components: {
        EditableInput,
        VueConfirmDialog
    },
    computed: {
        userProfile() {
            return this.$store.state.auth.userProfile
        },
        ruxList() {
            return this.$store.state.rux.ruxList
        },
        referralLink() {
            return this.$store.state.rux.referralLink
        },
        isReferralLinkEmpty() {
            return Object.keys(this.referralLink).length === 0
        }
    },
    methods: {
        updatedInput(val) {
            this.userProfile.name = val
            this.$store.dispatch('rux/updateProfile', this.userProfile)
        },
        deleteRux(serialNumber) {
            this.$confirm({
                message: 'Really remove this RUX from your account? This cannot be undone',
                buttons: [
                    {
                        text: 'Cancel',
                    },
                    {
                        text: 'Remove',
                        callback: () => {
                            this.$store.dispatch('rux/deleteRuxFromAccount', { serialNumber: serialNumber, route: '' })
                        },
                    },
                ],
                parent: this._uid,
            })
        },
        copyToClipboard() {
            navigator.clipboard.writeText(this.referralLink)
            this.$confirm({
              message: 'Copied to clipboard!',
              buttons: [
                {
                 text: 'OK',
                },
              ],
             parent: this._uid,
         })
        }
    },
    mounted() {
        this.ruxList.forEach(rux =>
          this.$store.dispatch('rux/checkReferralLink', rux.serialNumber)
        )
    }
}
</script>

<style lang='scss' scoped>
.head {
    font-weight: bold;
    padding-bottom: 8px;
    @include respond-to('sm') {
        font-weight: normal;
        padding-bottom: 0px;
    }
}
.border-bottom {
    border-bottom: solid 0.5px darkgray;
    margin-bottom: 10px;
    font-size: large;
}
.roman {
    font-family: "Neue Roman";
    text-transform: uppercase;
}
.row {
    align-items: center;
    justify-content: center;
}
.no-padding {
    padding-left: 0px;
    padding-right: 0px;
    @include respond-to('sm') {
        padding-left: 15px;
        padding-right: 15px;
    }
}
.grid {
    padding: 0px;
    text-align: left;
    @include respond-to('sm') {
        text-align: left;
        padding: 16px 0px;
        margin: 0px;
        border: none;
    }
}
.rux-list-title {
    font-family: "Neue Roman";
    font-size: 30px;
    text-align: left;
    margin-bottom: 20px;
}
.flex-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.deleteRux {
    font-size: 1.5rem;
    color: black;
    position: relative;
    padding-right: 5px;
}
.copy-button {
  background: none;
  border: none;
  cursor: pointer;
  width: 5px;
  height: 25px;
  transition: transform 0.2s ease-in-out;
}
.copy-button:active {
  transform: scale(1.2);
}
.copy-button:focus {
  outline: none;
}
.copy-button:focus-visible {
  outline: none;
}
.copy-icon {
  color: #f15d35;
  font-size: 20px;
  position: relative;
  top: 1px;
  right: 1px;
}
section {
    margin-top: 40px;
}
</style>